import * as React from 'react';
import {
    MultiSelectQuestion,
    SingleSelectQuestion,
    WritingQuestion,
    WritingQuestionType,
} from '../../../../../commonv3/types/writingQuestions';
import { action, computed, observable } from 'mobx';
import { MultiSelectAnswerState, SingleSelectAnswerState } from '../../writing_questions/states/QuestionAnswerState';

export class WritingSectionAnswerState {
    @observable questions = [];
    @observable singleSelectAnswers = observable.map();
    @observable multiSelectAnswers = observable.map();

    @action.bound
    init(questions: WritingQuestion[]) {
        this.questions = questions;
        this.singleSelectAnswers.clear();
        this.multiSelectAnswers.clear();
        questions.forEach((question) => {
            switch (question.question_type) {
                case WritingQuestionType.MULTI_SELECT:
                    const multiSelectAnswerState = new MultiSelectAnswerState();
                    multiSelectAnswerState.init(question);
                    this.multiSelectAnswers.set(question.id, multiSelectAnswerState);
                    break;
                case WritingQuestionType.SINGLE_SELECT:
                    const singleSelectAnswerState = new SingleSelectAnswerState();
                    singleSelectAnswerState.init(question);
                    this.singleSelectAnswers.set(question.id, singleSelectAnswerState);
                    break;
            }
        });
    }

    getSingleSelectAnswerState(question: SingleSelectQuestion): SingleSelectAnswerState {
        return this.singleSelectAnswers.get(question.id);
    }

    getMultiSelectAnswerState(question: MultiSelectQuestion): MultiSelectAnswerState {
        return this.multiSelectAnswers.get(question.id);
    }

    getAnswerState(question: WritingQuestion): SingleSelectAnswerState | MultiSelectAnswerState {
        switch (question.question_type) {
            case WritingQuestionType.MULTI_SELECT:
                return this.getMultiSelectAnswerState(question);
            case WritingQuestionType.SINGLE_SELECT:
                return this.getSingleSelectAnswerState(question);
        }
    }

    correctAnswersCount(): number {
        return this.questions.filter((q) => this.getAnswerState(q).isCorrect()).length;
    }

    @computed
    get score() {
        return Math.round(
            (100 * this.questions.filter((q) => this.getAnswerState(q).isCorrect()).length) / this.questions.length
        );
    }
}
